/* Stylesheets */
import './scss/vendors/bootstrap.scss'; // ref: https://getbootstrap.com/docs/5.3/customize/sass/#importing
// import './scss/vendors/swiper.scss'; // ref: https://swiperjs.com/get-started#installation
import './scss/vendors/hamburgers.scss'; // ref: https://jonsuh.com/hamburgers/#sass
import './scss/vendors/energy-saver.scss';
import './scss/fonts.scss';
import './scss/style.scss';

/* Scripts */
import { Modal } from 'bootstrap';                                                     // ref: https://getbootstrap.com/docs/5.3/getting-started/webpack/#import-bootstrap - Point 3.
import { formatGeneral } from 'cleave-zen';                                                        // ref: https://github.com/nosir/cleave-zen

// import Swiper from 'swiper';                                                                 // ref: https://swiperjs.com/get-started#install-from-npm
// import { Navigation, Pagination, A11y, Autoplay, Mousewheel } from 'swiper/modules';

import { library, dom } from '@fortawesome/fontawesome-svg-core';  // ref: https://fontawesome.com/docs/apis/javascript/import-icons#package-names
import { faTriangleExclamation, faCalendar, faChevronsRight } from '@fortawesome/pro-regular-svg-icons';
import { faCircleChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { faTiktok, faInstagram, faFacebook } from '@fortawesome/free-brands-svg-icons';                        
library.add(faTriangleExclamation, faCalendar, faChevronsRight, faCircleChevronDown, faTiktok, faInstagram, faFacebook);
dom.i2svg();

import EnergySaver from './js/vendors/energy-saver';
const energyS = new EnergySaver();

/* Init Functions on DOMContentLoaded */
const ready = (callback) => {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
};

/* Variables and functions */
const isDebug = process.env.NODE_ENV !== 'production';
const initWebpackVersion = () => {
    isDebug && console.log(`%c${DESCRIPTION}`, `color: #9ac456; font-size: 18px; font-weight: 700;`, `Version ${VERSION} - Development Environment`);
};

// Scroll to section
const scrollToSection = (id) => {
    let anchor = document.querySelector(`[data-anchor="${id}" ]`);
    let headerHeight = document.querySelector('nav').offsetHeight;
    let anchorPositionY = anchor.getBoundingClientRect().top;
    window.scrollBy(0, anchorPositionY-headerHeight);

    if (window.history.pushState) {
        window.history.pushState(null, null, window.location.pathname + window.location.search);
    } else {
        window.location.hash = '';
    }
}

//Close Bootstrap Menu on navlink click
const closeMenuByNav = () => {
    let navLink = document.querySelectorAll('.nav-link');

    if(navLink) {
        let navbar = document.getElementById('navbarNavAltMarkup');
        navLink.forEach((el) => el.addEventListener('click', (evt) => {
            navbar.classList.remove('show');
            document.querySelector('button.navbar-toggler').classList.add('collapsed'); 
        }));
    }
}
window.closeMenuByNav = closeMenuByNav;

// Cleave
import Cleave from 'cleave.js';
const initCleave = () => {   

    // UTENTE ****************

    // DATA NASCITA
    const txtDataNascita = document.querySelector('#Input_DataNascita')
    if (txtDataNascita) {
        new Cleave(txtDataNascita, {
            date: true,
            delimiter: '/',
            datePattern: ['d', 'm', 'Y']
        })
    }

    // CAP
    const txtCAP = document.querySelector('#Input_Cap')
    if (txtCAP) {
        new Cleave(txtCAP, {
            blocks: [5],
            numericOnly: true
        })
    }

}

// Check page scroll
let scrollTop;
document.addEventListener("scroll", (event) => {
    scrollTop = (window.scrollY !== undefined) ? window.scrollY : (document.documentElement || document.body.parentNode || document.body).scrollTop; 
});

// Fetch all the forms we want to apply custom Bootstrap validation styles to
const initFormValidation = () => {
    const forms = document.querySelectorAll('.needs-validation');
    if (forms) {
        Array.from(forms).forEach(form => {

            let allInputs = form.querySelectorAll('input, select, textarea');
            allInputs.forEach(function (el) {
                el.addEventListener('change', function (event) {
                    if (el.checkValidity()) {
                        el.removeAttribute('aria-invalid');
                    } else {
                        el.setAttribute('aria-invalid', 'true');
                    }
                });
            });

            form.addEventListener('submit', e => {
                form.classList.add('was-validated');

                let validFields = form.querySelectorAll('*:valid');
                let invalidFields = form.querySelectorAll('*:invalid');
                validFields.forEach(function (validField) {
                    validField.removeAttribute('aria-invalid');
                });
                invalidFields.forEach(function (invalidField) {
                    invalidField.setAttribute('aria-invalid', 'true');
                });

                if (!form.checkValidity()) {
                    e.preventDefault()
                    e.stopPropagation()
                    invalidFields[0].focus();
                } else {
                    document.querySelector('.btn-submit').classList.add('d-none');
                    document.querySelector('.btn-loading').classList.remove('d-none');
                    document.querySelector('.loader-layer').classList.remove('d-none');
                }
            }, false);
        });
    }
}


/* Ready callback function */
ready(() => {
    initWebpackVersion();
    initCleave();
    initFormValidation();
    closeMenuByNav();
});

window.scrollToSection = scrollToSection;